import { Route, Routes } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import UserGuide from "./UserGuide";
import NeedHelp from "./NeedHelp";
import useRefreshToken from "../../Hooks/usegenerateToken";
import { AuthConsole } from "../../Utils/helper";
const HelpandSupport=()=>{
    // useRefreshToken();
    const [height, setHeight]=useState(window.innerHeight - 240)
    const [activeTab, setActiveTab]=useState("DOCS")
    AuthConsole(activeTab);
    
    useEffect(() => {
        const handleResize = () => {
          setHeight(window.innerHeight - 240)
        };
    
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [])
    return(
        <>
        <h1 style={{margin:"0px 25px", backgroundColor:"white", width:"100%", padding:"15px", borderBottom:"1px solid lightgray",position:"fixed"}}>Help & Support</h1>
        <div style={{width:"100%", height:"10px", backgroundColor:"rgb(241, 241, 241)"}}/>

            <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}/>
                <div className="w-100" style={{marginLeft:"22rem", marginTop:'5rem'}}>
                    {/* <Routes> */}
                        <UserGuide activeTab={activeTab}/>
                        {/* <Route path="/IssueDocument" element={<h1>IssueDocument</h1>}/>
                        <Route path="/CreateDocument" element={<h1>CreateDocument</h1>}/>
                        <Route path="/EditTemplate" element={<h1>EditTemplate</h1>}/>
                        <Route path="/Manage_issued_documents" element={<h1>Manage issued documents</h1>}/>
                        <Route path="/Manage_Change_Request" element={<h1>Manage Change Request</h1>}/>
                        <Route path="/Edit_Profile" element={<h1>Edit Profile</h1>}/> */}

                    {/* </Routes> */}
                    {/* <NeedHelp/> */}
                </div>
        </>
    )
}
export default HelpandSupport;